import { LongGameError } from '@long-game/common';
export * from './errors.js';
export * from './gameDefinition.js';
export { GameRandom } from './random.js';
export * from './rounds.js';
export * from './stateCache.js';
export { emptyGameDefinition } from './empty.js';
export function normalizeGameVersion(version) {
    if (typeof version === 'number') {
        return `v${version}`;
    }
    if (typeof version === 'string') {
        // remove "x.y" minor versions... no longer used.
        if (version.includes('.')) {
            version = version.split('.')[0];
        }
        if (!version.startsWith('v')) {
            return `v${version}`;
        }
        return version;
    }
}
export function getVersion(game, version) {
    const found = game.versions.find((v) => v.version === normalizeGameVersion(version));
    if (!found) {
        throw new LongGameError(LongGameError.Code.BadRequest, `Version ${version} not found for game ${game.id}`);
    }
    return found;
}
export function getLatestVersion(game) {
    const latest = game.versions.at(-1);
    if (!latest) {
        throw new LongGameError(LongGameError.Code.BadRequest, `No versions found for game ${game.id}`);
    }
    return latest;
}
//# sourceMappingURL=index.js.map